import React, { useEffect, useState } from 'react';
import { useIntersect } from '@wix/experts-common';
import TemplateLoadedCard from './TemplateLoadedCard';
import TemplateLoadingCard from './TemplateLoadingCard';
import TemplateCardLinkWrapper from './TemplateCardLinkWrapper';
const TemplateCard = _ref => {
  let {
    template,
    forceRender,
    loader = false,
    index,
    t,
    onClick,
    templateHref,
    overlayContent,
    CardInfo,
    anchorProps,
    mediaContainerClassName,
    loadedCardClassName,
    showFeatures,
    loadingCardHeight,
    loadingSkeletonHeight,
    noBackground
  } = _ref;
  const [hover, setHover] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_focused, setFocused] = useState(false);
  const [ready, setReady] = useState(false || forceRender);
  const [ref, entryElement] = useIntersect({});
  useEffect(() => {
    if (entryElement.intersectionRatio === 1 && !ready && !loader) {
      setTimeout(() => {
        setReady(true);
      }, 200);
    }
  }, [ready, entryElement]);
  return /*#__PURE__*/React.createElement(TemplateCardLinkWrapper, {
    template: template,
    templateHref: templateHref,
    onClick: onClick,
    setHover: setHover,
    setFocused: setFocused,
    t: t,
    anchorProps: anchorProps
  }, ready ? /*#__PURE__*/React.createElement(TemplateLoadedCard, {
    template: template,
    setHover: setHover,
    hover: hover,
    index: index,
    overlayContent: overlayContent,
    CardInfo: CardInfo,
    mediaContainerClassName: mediaContainerClassName,
    loadedCardClassName: loadedCardClassName,
    showFeatures: showFeatures
  }) : /*#__PURE__*/React.createElement(TemplateLoadingCard, {
    ref: ref,
    componentHeight: loadingCardHeight,
    skeletonHeight: loadingSkeletonHeight,
    noBackground: noBackground
  }));
};
export default TemplateCard;
//# sourceMappingURL=TemplateCard.js.map